import _ from 'lodash';
import { sqConditionRuntimeStore, sqTrendConditionStore } from '@/core/core.stores';
import { LIMIT_SIZE_1000 } from '@/main/app.constants';
import { isConditionMonitorNotificationsEnabled } from '@/services/systemConfiguration.utilities';
import { isCanceled } from '@/utilities/http.utilities';
import { logError } from '@/utilities/logger';
import { isPresentationWorkbookMode } from '@/utilities/workbookMode.utilities';
import {
  GetConditionMonitorMetadataListSortByEnum as SortByEnum,
  sqConditionMonitorsApi,
} from '@seeqdev/api/endpoint/ConditionMonitorsApi';

export async function fetchMonitoredConditionIds(conditionIds: string[]): Promise<void> {
  if (!isConditionMonitorNotificationsEnabled() || isPresentationWorkbookMode() || _.isEmpty(conditionIds)) {
    return;
  }

  try {
    const {
      data: { conditionMonitorMetadataList },
    } = await sqConditionMonitorsApi.getConditionMonitorMetadataList({
      conditionIds,
      sortBy: SortByEnum.Name,
      limit: LIMIT_SIZE_1000,
    });

    sqConditionRuntimeStore.actions.setMonitors({ conditionIds, conditionMonitorMetadataList });
  } catch (e) {
    if (!isCanceled(e)) {
      logError(_.toString(e));
    }
  }
}

/** Refreshes which monitors watch each condition on the trend */
export function fetchTrendMonitoredConditionIds(): Promise<void> {
  return fetchMonitoredConditionIds(sqTrendConditionStore.items.map((item) => item.id));
}
